import React, { useEffect, useState } from 'react';
import { Alert, Card, Col, Row, Select, Typography } from 'antd';
import { IndicatorsMap } from '../map/IndicatorMap';
import { fetchIndicatorsData } from '../../externalAPI/planetAPI';
import { Indicator } from '../../interfaces';

const { Text, Link } = Typography;

const IndicatorsConservation: React.FC = () => {
  // Local state for storing the fetched indicators data and the selected indicator value
  const [indicators, setIndicators] = useState<Indicator[]>([]);
  const [selectedIndicator, setSelectedIndicator] = useState<string | undefined>(undefined);

  useEffect(() => {
    async function fetchData() {
      try {
        const data: Indicator[] = await fetchIndicatorsData();
        setIndicators(data);
      } catch (error) {
        console.error('Error fetching indicators data:', error);
      }
    }
    fetchData();
  }, []);

  // Find the selected indicator object from the fetched data
  const currentIndicator = indicators.find((ind) => ind.alias === selectedIndicator);

  return (
    <div>
      <h1 style={{ marginBottom: '20px', color: '#329619', fontSize: '25px' }}>Home &gt; Indicators</h1>
      <Row>
        <Col span={24}>
          <Card>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ fontWeight: 'bold', fontSize: '16px' }}>Indicators:</span>
                <Select
                  id='indicatorSelect'
                  placeholder='Select an indicator'
                  style={{ minWidth: '200px' }}
                  value={selectedIndicator || undefined}
                  onChange={(value) => setSelectedIndicator(value)}
                >
                  {indicators.map((indicator) => (
                    <Select.Option key={indicator.alias} value={indicator.alias}>
                      {indicator.name}
                    </Select.Option>
                  ))}
                </Select>
              </div>
              <div style={{ fontSize: '14px', color: '#555' }}>
                <strong>Description:&nbsp;</strong>
                {currentIndicator ? currentIndicator.description : 'No description available'}
              </div>
            </div>
          </Card>
          {/* New Alert with the GeoPl@ntNet link */}
          <Alert
            type='info'
            showIcon
            style={{ marginTop: '16px' }}
            message={
              <>
                <Text strong>Data Source:</Text> GeoPl@ntNet
                <br />
                <Link href='https://guarden.org/technologies/geoplantnet/' target='_blank'>
                  Learn more about GeoPl@ntNet
                </Link>
              </>
            }
          />
        </Col>
        <Col span={24} style={{ paddingTop: '5px' }}>
          <Card>
            <IndicatorsMap indicatorAlias={currentIndicator?.alias} />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default IndicatorsConservation;
